import { render } from "./PChart.vue?vue&type=template&id=98bf6648"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98bf6648"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98bf6648', __exports__)) {
    api.reload('98bf6648', __exports__)
  }
  
  module.hot.accept("./PChart.vue?vue&type=template&id=98bf6648", () => {
    api.rerender('98bf6648', render)
  })

}


export default __exports__